import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { bool, string } from 'prop-types'
import { navigate } from '@reach/router'
import Link from '../../components/Link/Link'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import {
  DESCRICAO_PAGINA_NAO_ENCONTRADA,
  LINKS_PAGINA_NAO_ENCONTRADA_ASSOCIADO_LOGADO,
  LINKS_PAGINA_NAO_ENCONTRADA_ASSOCIADO_NAO_LOGADO,
  STATUS_PAGINA_NAO_ENCONTRADA,
  TITULO_APOIO_PAGINA_NAO_ENCONTRADA
} from './constantsPaginaNaoEncontrada'
import { useGlobal } from '../../contexts/GlobalContext'
import { isEmptyObject } from '../../utils/helpers/helpers'

const WrapperPaginaNaoEncontrada = styled.section`
  align-items: center;
  display: flex;
  height: calc(100vh - 75px);
  justify-content: center;
`

const ConteudoNaoEncontrado = styled.div`
  margin: 0 auto;
  max-width: 500px;
  text-align: center;

  h1 {
    color: ${StyleGuide.cores.azul};
    font-size: 200px;
    line-height: 1;

    small {
      color: ${StyleGuide.cores.cinza500};
      display: block;
      font-size: 24px;

      @media (min-width: ${StyleGuide.mediaQuery.tablet}) {
        font-size: 40px;
      }
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 100px;
    }
  }

  p {
    ${StyleGuide.tipografia.textoGrande}
  }

  ul {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;

    li {
      & > * {
        color: ${StyleGuide.cores.azul};
        border-bottom: 1px solid ${StyleGuide.cores.azul};
      }
    }
  }

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 310px;
  }
`

const PaginaNaoEncontrada = ( { isComponente, pathParaRedirecionamento } ) => {
  const { isAssociadoLogado, setShouldShowMenu } = useGlobal()
  const [ links, setLinks ] = useState( {} )

  if ( isComponente && pathParaRedirecionamento ) {
    navigate( pathParaRedirecionamento )
    return null
  }

  useEffect( () => {
    setShouldShowMenu( false )
  }, [] )

  useEffect( () => {
    let link
    if ( isAssociadoLogado ) {
      link = LINKS_PAGINA_NAO_ENCONTRADA_ASSOCIADO_LOGADO
    } else {
      link = LINKS_PAGINA_NAO_ENCONTRADA_ASSOCIADO_NAO_LOGADO
    }
    setLinks( link )
  }, [ isAssociadoLogado ] )

  const handleLinkClick = () => {
    setShouldShowMenu( true )
  }

  return (
    <WrapperPaginaNaoEncontrada>
      <ConteudoNaoEncontrado>
        <h1>
          { STATUS_PAGINA_NAO_ENCONTRADA }

          <small>{ TITULO_APOIO_PAGINA_NAO_ENCONTRADA }</small>
        </h1>

        <p>{ DESCRICAO_PAGINA_NAO_ENCONTRADA }</p>

        <ul>
          { !isEmptyObject( links ) && Object.entries( links ).map( linksMenu => {
            const [ chave, objeto ] = linksMenu
            return (
              <li key={ chave }>
                <Link
                  onClick={ handleLinkClick }
                  to={ objeto.slug }
                >
                  { objeto.nome }
                </Link>
              </li>
            )
          } ) }
        </ul>
      </ConteudoNaoEncontrado>
    </WrapperPaginaNaoEncontrada>
  )
}

PaginaNaoEncontrada.defaultProps = {
  'isComponente': false,
  'pathParaRedirecionamento': null
}

PaginaNaoEncontrada.propTypes = {
  'isComponente': bool,
  'pathParaRedirecionamento': string
}

export default PaginaNaoEncontrada
